import { PaymentType } from '@afterpay/types'

export enum BankAccountSupportedPaymentTypes {
  PBI = PaymentType.PBI,
  PAD = PaymentType.PAD,
}
